import "./doyenAccessServices.css";

const Services = () => {
  return (
    <div>
      <div className="text-center mt-[6em] w-[570px] mx-auto">
        <h1 className="text-[24px] font-medium">Our Mentorship Services</h1>
        <p className="text-[#636363]">
          Experience empowered growth through our meticulously tailored
          mentorship services. Unlock your full potential with personalized
          guidance and support
        </p>
      </div>

      <div style={{ marginTop: "70px" }}>
        <div className="grid grid-cols-3 gap-y-6 w-full sm:grid-cols-2 sm:w-[138vw] md:grid-cols-2 md:gap-y-4 sm:gap-4">
          <div className="col-md-4">
            <div className="rounded-xl p-5 sm:p-2 flex flex-col items-center text-center gap-2 h-[291px] w-[430px] sm:w-[250px] md:w-[300px] bg-[#F7F7F7]">
              <img
                src="/images/doyen_access/direct_access.svg"
                alt=""
                className="h-[70px] w-[70px] sm:h-[50px] sm:w-[50px] mb-2 sm:mt-[-1em] md:mt-[-1em]"
              />
              <h5 className="text-[20px] sm:text-base font-bold text-[#222222]">
                Direct Access to Industry Leaders
              </h5>
              <p className="text-[#636363] sm:text-[14px]">
                Connect with renowned industry experts for personalized
                consultations and insights.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="rounded-xl p-5 sm:p-2 flex flex-col items-center text-center gap-2 h-[291px] w-[430px] sm:w-[250px]  md:w-[300px] bg-[#F7F7F7]">
              <img
                src="/images/doyen_access/exclusive.svg"
                alt=""
                className="h-[70px] w-[70px] sm:h-[50px] sm:w-[50px] mb-2 sm:mt-[-1em] md:mt-[-1em]"
              />
              <h5 className="text-[20px] sm:text-base font-bold text-[#222222]">
                Exclusive Webinars and Workshops
              </h5>
              <p className="text-[#636363] sm:text-[14px]">
                Access exclusive webinars and workshops hosted by industry
                titans covering the latest trends and strategies.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="rounded-xl p-5 sm:p-2 flex flex-col items-center text-center gap-2 h-[291px] w-[430px] sm:w-[250px]  md:w-[300px] bg-[#F7F7F7]">
              <img
                src="/images/doyen_access/knowledge.svg"
                alt=""
                className="h-[70px] w-[70px] sm:h-[50px] sm:w-[50px] mb-2 sm:mt-[-1em] md:mt-[-1em]"
              />
              <h5 className="text-[20px] sm:text-base font-bold text-[#222222]">
                Knowledge Repository
              </h5>
              <p className="text-[#636363] sm:text-[14px]">
                Gain unlimited access to a curated knowledge repository filled
                with expert articles, case studies, and research papers.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="rounded-xl p-5 sm:p-2 flex flex-col items-center text-center gap-2 h-[291px] w-[430px] sm:w-[250px]  md:w-[300px] bg-[#F7F7F7]">
              <img
                src="/images/doyen_access/networking.svg"
                alt=""
                className="h-[70px] w-[70px] sm:h-[50px] sm:w-[50px] mb-2 sm:mt-[-1em] md:mt-[-1em]"
              />
              <h5 className="text-[20px] sm:text-base font-bold text-[#222222]">
                Networking Opportunities
              </h5>
              <p className="text-[#636363] sm:text-[14px]">
                Join a thriving community of professionals and network with
                industry experts at virtual events.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="rounded-xl p-5 sm:p-2 flex flex-col items-center text-center gap-2 h-[291px] w-[430px] sm:w-[250px]  md:w-[300px] bg-[#F7F7F7]">
              <img
                src="/images/doyen_access/reports.svg"
                alt=""
                className="h-[70px] w-[70px] sm:h-[50px] sm:w-[50px] mb-2 sm:mt-[-1em] md:mt-[-1em]"
              />
              <h5 className="text-[20px] sm:text-base font-bold text-[#222222]">
                Customized Reports and Insights
              </h5>
              <p className="text-[#636363] sm:text-[14px]">
                Receive personalized reports and insights tailored to your
                industry and business needs.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>
        <div className="row"></div>
      </div>
    </div>
  );
};

export default Services;
